import { useIntl } from 'react-intl';

import { Icon } from '@/components/Icon';
import type { ButtonProps } from '@/components/LegacyButton';
import { LegacyButton } from '@/components/LegacyButton';
import { pdpMessages } from '@/messages/product';

import { ReactComponent as DownloadSvg } from '@/assets/download.svg';

export const DownloadLink = (props: ButtonProps) => {
  const { formatMessage } = useIntl();

  return (
    <LegacyButton
      label={formatMessage(pdpMessages.downloadUserManual)}
      leftContent={<DownloadSvg />}
      size='l'
      variant='link'
      width='auto'
      {...props}
    >
      <Icon name='chevronRight' />
    </LegacyButton>
  );
};
